import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const Careers = loadable(() => import('./JobDetail'));

Careers.getInitialState = getInitialState;

export default Careers;
